import script from "./AdminShellPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminShellPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminShellPage.vue?vue&type=style&index=0&id=54a826ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a826ba"]])

export default __exports__